module.exports = __webpack_public_path__ + "static/media/grocery-javascript.3564e032.JPG";